import React, {useEffect, useState} from 'react';
import {isMobile} from 'react-device-detect';
import {useDispatch, useSelector} from 'react-redux';
import BtnSubmit from 'app/Components/Shared/Buttons/BtnSubmit';
import UpdatePaymentBanStrip from '../SharedComponents/UpdatePaymentBanStrip';
import {useSelectedBansForUpdatePayment} from '../hooks/useSelectedBansForUpdatePayment';
import {popupEnum} from '../Constants/debtPaymentEnum';
import Image from 'app/Components/Shared/Image/image';
import {
  checkBankObligationSignatureFile,
  getBankObligationSignatureFile,
  selectBankObligationInfo,
  selectSelectedBanData,
  selectSignatureFile,
  selectServerData,
  selectEpiData,
  setShowPopup,
  setSignatureFileSigned,
  submitBankPaymentMethod,
} from '../DebtAndUpdatePaymentBlockSlice';
import Config from 'app/Config';
import {dwhUpdatePaymentMethodReport, DwhActionType, DWHMessageText, DWHStatus} from '../reports/dwhReports';
const STEP_TITLE = 'הוראת קבע דרך חשבון בנק';
const STEP_SUBTITLE = 'כדי לבצע תשלום בהוראת קבע, אנחנו צריכים את החתימה שלך בטופס המצורף';
const INFO_MESSAGE = 'החתימה צריכה להיות זהה לחתימה בבנק';
const SIGN_BUTTON_TEXT = 'לצפייה וחתימה על טופס תשלום חודשי <br/> באמצעות הוראת קבע';
const SIGNED_MESSAGE = 'הטופס עודכן';

const documentIcon = require('../images/signature-form-document.svg');
const chevronIcon = require('../images/chevron.svg');
const signedIcon = require('../images/check.svg');
const loadingIcon = require('../images/file-loading.svg');
const BankFormSignature = () => {
  const dispatch = useDispatch();
  const signatureFile = useSelector(selectSignatureFile);
  const selectedBanData = useSelector(selectSelectedBanData);
  const bankObligationInfo = useSelector(selectBankObligationInfo);
  const selectedBansForUpdate = useSelectedBansForUpdatePayment();
  const allBans = useSelector(selectServerData);
  const epiData = useSelector(selectEpiData);
  const loginData = useSelector((state) => state.authentication.loginData);
  const [showSignForm, setShowSignForm] = useState(false);
  const [error, setError] = useState(false);
  const [fileError, setFileError] = useState(false);
  const footer = document.getElementsByClassName('footer-container')[0];
  const el = document.getElementsByClassName('debt-update-payment-block')[0];
  const iconBankSignatureWarning = epiData?.iconBankSignatureWarning;

  const getStandingOrderFormReportData = (overrides = {}) => ({
    banData: selectedBanData,
    loginData,
    allBans,
    selectedBanNumbers: selectedBansForUpdate?.map((ban) => ban.banNumber),
    lastPaymentTypeValidation: epiData?.lastPaymentTypeValidation,
    ...overrides,
  });

  useEffect(() => {
    dwhUpdatePaymentMethodReport({
      ...getStandingOrderFormReportData(),
      actionType: DwhActionType.StandingOrderFormPage,
      messageText: DWHMessageText.SettingAStandingOrderPageDisplayed,
      status: DWHStatus.Ongoing,
    });
  }, []);

  const closeSignatureForm = () => {
    setShowSignForm(false);
    if (el) {
      el.classList.remove('fileOpen');
    }
    if (footer) {
      footer.style.display = '';
    }
  };

  const openSignatureForm = () => {
    setShowSignForm(true);
    if (el) {
      el.classList.add('fileOpen');
    }
    if (footer) {
      footer.style.display = 'none';
    }
  };

  useEffect(() => {
    if (!showSignForm) {
      return;
    }

    const handleSignComplete = (event) => {
      if (event.data?.type === 'ESignStatus' && event.data?.status === 'ok') {
        dispatch(setSignatureFileSigned(true));
        closeSignatureForm();
      }
    };

    window.addEventListener('message', handleSignComplete);
    return () => window.removeEventListener('message', handleSignComplete);
  }, [showSignForm, dispatch]);

  useEffect(() => {
    return () => {
      if (el) {
        el.classList.remove('fileOpen');
      }
      if (footer) {
        footer.style.display = '';
      }
    };
  }, []);
  useEffect(() => {
    return () => {
      if (signatureFile.error) {
        setFileError(true);
      }
      if (!signatureFile.error || signatureFile.loading) {
        setFileError(false);
      }
    };
  }, [signatureFile.error, signatureFile.loading]);

  const openUpdateBansDetailsPopup = () => {
    dispatch(setShowPopup({showPopUp: true, popupType: popupEnum.UPDATE_PAYMENT_BANS_DETAILS}));
  };

  const handleSignClick = async () => {
    setError(false);
    if (signatureFile.isSigned) {
      return;
    }

    const action = await dispatch(getBankObligationSignatureFile());
    if (!getBankObligationSignatureFile.fulfilled.match(action) || !action.payload?.isSuccess) {
      return;
    }

    if (!action.payload.isSigned && action.payload.signUrl) {
      openSignatureForm();
    }
  };

  async function handleUpdateComplete() {
    if (!signatureFile.isSigned) {
      setError(true);
      return;
    }

    dwhUpdatePaymentMethodReport({
      ...getStandingOrderFormReportData(),
      actionType: DwhActionType.StandingOrderFormPage,
      messageText: DWHMessageText.StandingOrderFormPageButtonClicked,
      status: DWHStatus.Ongoing,
    });

    const checkAction = await dispatch(checkBankObligationSignatureFile());
    if (
      !checkBankObligationSignatureFile.fulfilled.match(checkAction) ||
      !checkAction.payload?.isSuccess ||
      !checkAction.payload?.isSigned
    ) {
      return;
    }

    const reqData = {
      BanNumber: selectedBanData.banNumber,
      BankAccountNumber: bankObligationInfo.bankAccountNo,
      BankCode: bankObligationInfo.bankCode,
      BankBranchCode: bankObligationInfo.branchCode,
      BankDescription: bankObligationInfo.bankName,
    };

    await dispatch(submitBankPaymentMethod(reqData));
  }

  const getImage = () => {
    if (signatureFile.loading) {
      return <Image src={loadingIcon} alt='' className='form-signature-step__sign-button-chevron' />;
    }
    if (signatureFile.isSigned) {
      return <Image src={signedIcon} alt='' className='form-signature-step__sign-button-chevron' />;
    }
    return <Image src={chevronIcon} alt='' className='form-signature-step__sign-button-chevron' />;
  };

  return (
    <div className='debtpayment-step form-signature-step'>
      {showSignForm && signatureFile.url && (
        <div>
          <iframe className='form-signature-step__iframe' src={signatureFile.url} />
        </div>
      )}
      <UpdatePaymentBanStrip selectedBans={selectedBansForUpdate} onDetailsClick={openUpdateBansDetailsPopup} />

      <div className={`form-signature-step__title ${isMobile ? 'm-title' : 'l-title'} extra`}>{STEP_TITLE}</div>

      <p className={`form-signature-step__subtitle ${isMobile ? 's-title-small' : 'm-title'}`}>{STEP_SUBTITLE}</p>

      <div className='form-signature-step__info-banner'>
        {iconBankSignatureWarning && (
          <Image src={Config.epiBaseUrl + iconBankSignatureWarning} alt='image' className='form-signature-step__info-banner-icon' />
        )}
        <p className='form-signature-step__info-banner-text'>{INFO_MESSAGE}</p>
      </div>

      <div className={`form-signature-step__sign-button-container ${signatureFile.loading ? 'file-loading' : ''}`}>
        <button
          type='button'
          className={`form-signature-step__sign-button ${signatureFile.isSigned ? 'form-signature-step__sign-button--signed' : ''}`}
          onClick={handleSignClick}
          disabled={signatureFile.isSigned}>
          <Image src={documentIcon} alt='' className='form-signature-step__sign-button-icon' />
          <span
            className='form-signature-step__sign-button-text'
            dangerouslySetInnerHTML={{__html: signatureFile.isSigned ? SIGNED_MESSAGE : SIGN_BUTTON_TEXT}}></span>
          {getImage()}
        </button>
        {fileError && <div className='error red'>לא הצלחנו לטעון את הטופס, אפשר לנסות שוב </div>}
      </div>

      <div className='continue-button'>
        {error && <div className='error red'>כדי להתקדם יש לחתום על הטופס</div>}
        <BtnSubmit
          text='עדכון וסיום'
          onclick={() => {
            handleUpdateComplete();
          }}
        />
      </div>
    </div>
  );
};

export default BankFormSignature;
